/* @ngInject */
class Reports {
	constructor(moment) {
		this.moment = moment;
	}

	financialYear(year = null) {
		if (year === null) {
			const now = this.moment();

			switch (now.quarter()) {
				case 1:
				case 2: {
					// End of financial year
					year = now.subtract(1, 'year')
					          .year();

					break;
				}

				case 3:
				case 4: {
					year = now.year();

					break;
				}
			}
		}

		const start = this.moment()
		                  .startOf('year')
		                  .year(year)
		                  .quarter(3)
		                  .startOf('day');

		const end = this.moment()
		                .startOf('year')
		                .year(year)
		                .add(1, 'year')
		                .quarter(3)
		                .subtract(1, 'day')
		                .endOf('day');

		return {
			start,
			end,
		};
	}

	businessWeek() {
		this.moment.updateLocale('en', {
			week: {
				dow: 1, // First day of week is Monday
				doy: 4,  // First week of year must contain 4 January (7 + 1 - 4)
			},
		});

		const start = this.moment()
		                  .startOf('week')
		                  .startOf('day');

		const end = this.moment()
		                .startOf('week')
		                .add(1, 'week')
		                .subtract(1, 'day')
		                .endOf('day');

		return {
			start,
			end,
		};
	}

	businessFortnight() {
		this.moment.updateLocale('en', {
			week: {
				dow: 1, // First day of week is Monday
				doy: 4,  // First week of year must contain 4 January (7 + 1 - 4)
			},
		});

		const start = this.moment()
		                  .startOf('week')
		                  .startOf('day');

		const end = this.moment()
		                .startOf('week')
		                .add(2, 'week')
		                .subtract(1, 'day')
		                .endOf('day');

		return {
			start,
			end,
		};
	}

	payFortnight() {
		this.moment.updateLocale('en', {
			week: {
				dow: 1, // First day of week is Monday
				doy: 4, // First week of year must contain 4 January (7 + 1 - 4)
			},
		});

		const weeks = this.moment()
		                  .startOf('day')
		                  .diff(this.moment.unix(1566136800), 'weeks');

		let start;
		let end;

		if (weeks % 2 === 0) {
			// This is the start of a pay fortnight
			start = this.moment()
			            .startOf('week')
			            .startOf('day');

			end = this.moment()
			          .startOf('week')
			          .add(2, 'week')
			          .subtract(1, 'day')
			          .endOf('day');
		} else {
			// This is not the start of a pay fortnight
			start = this.moment()
			            .startOf('week')
			            .startOf('day')
			            .subtract(1, 'week');

			end = this.moment()
			          .startOf('week')
			          .add(2, 'week')
			          .subtract(1, 'day')
			          .endOf('day')
			          .subtract(1, 'week');
		}

		return {
			start,
			end,
		};
	}

	rosterPeriod() {
		// This function is only used for staff reporting, and not for users loading their own rosters
		// Do not use it for temporary roster release time changes

		this.moment.updateLocale('en', {
			week: {
				dow: 1, // First day of week is Monday
				doy: 4, // First week of year must contain 4 January (7 + 1 - 4)
			},
		});

		const daysSinceMonday = this.moment()
		                            .weekday();

		const getTimesPriorToCutoff = () => {
			let start = this.moment()
			                .startOf('week')
			                .startOf('day')
			                .subtract(1, 'week');

			let end = this.moment()
			              .startOf('week')
			              .add(2, 'week')
			              .subtract(1, 'day')
			              .endOf('day');

			return {
				start,
				end,
			};
		};

		const getTimesAfterCutoff = () => {
			let start = this.moment()
			                .startOf('week')
			                .startOf('day');

			let end = this.moment()
			              .startOf('week')
			              .add(2, 'week')
			              .subtract(1, 'day')
			              .endOf('day');

			return {
				start,
				end,
			};
		};

		switch (daysSinceMonday) {
			case 0: // Monday
			case 1: // Tuesday
			case 2: // Wednesday
			{
				return getTimesPriorToCutoff();
			}

			case 3: // Thursday
			{
				const hour = this.moment()
				                 .hour();

				const minute = this.moment()
				                   .hour();

				if (hour < 14 || (hour === 14 && minute < 30)) {
					return getTimesPriorToCutoff();
				} else {
					return getTimesAfterCutoff();
				}
			}

			case 4: // Friday
			case 5: // Saturday
			case 6: // Sunday
			{
				return getTimesAfterCutoff();
			}
		}
	}

	visitFortnight(cutoff) {
		// This function is used for users loading their own rosters
		// Do use it for temporary roster release time changes

		this.moment.updateLocale('en', {
			week: {
				dow: 1, // First day of week is Monday
				doy: 4, // First week of year must contain 4 January (7 + 1 - 4)
			},
		});

		const getTimesPriorToCutoff = () => {
			let start = this.moment()
			                .startOf('week')
			                .startOf('day')
			                .subtract(1, 'week');

			let end = this.moment()
			              .startOf('week')
			              .add(1, 'week')
			              .subtract(1, 'day')
			              .endOf('day');

			return {
				start,
				end,
			};
		};

		const getTimesAfterCutoff = () => {
			let start = this.moment()
			                .startOf('week')
			                .startOf('day');

			let end = this.moment()
			              .startOf('week')
			              .add(2, 'week')
			              .subtract(1, 'day')
			              .endOf('day');

			return {
				start,
				end,
			};
		};

		const now = this.moment().unix();

		if (now < cutoff) {
			return getTimesPriorToCutoff();
		} else {
			return getTimesAfterCutoff();
		}
	}
}

export default Reports;


// WEBPACK FOOTER //
// ./src/js/services/reports/index.js